import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { BugOff, Handshake, Wrench } from "lucide-react";

export const useQuestTypeConfig = () => {
  const { t } = useResource();

  return {
    BugHunter: {
      label: t(Resources.Pages.DetailQuest.Types.BugHunter),
      icon: BugOff,
    },
    Engineering: {
      label: t(Resources.Pages.DetailQuest.Types.Engineering),
      icon: Wrench,
    },
    Mentoring: {
      label: t(Resources.Pages.DetailQuest.Types.Mentoring),
      icon: Handshake,
    },
  };
};

export type QuestType = keyof ReturnType<typeof useQuestTypeConfig>;
